import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ResponseApiTrackingMegamovil } from "../../types/common";
import { trackingMegamovil } from "../../methods/Methods";

//-------------------------------------------------------------------------------------------------- Interfaces
export interface FillTrackingMegaMovileSliceInterface {
    clientId: string;
}

export interface TrackingMegaMovilData extends ResponseApiTrackingMegamovil {
    clientId: string;
}

//-------------------------------------------------------------------------------------------------- Vars and consts
const movilTrackingInitialState: TrackingMegaMovilData = {
    clientId: "",
    status: false,
    message: "",
    paquete: "",
    estadoContratacion: "",
    fecha: "",
};

//-------------------------------------------------------------------------------------------------- Thunks
const fillMegaMovilTrackingSlice = createAsyncThunk(
    "thunk/megaMovil",
    async (obj: FillTrackingMegaMovileSliceInterface): Promise<TrackingMegaMovilData> => {
        let data: TrackingMegaMovilData = {
            clientId: obj.clientId,
            status: false,
            message: "",
            paquete: "",
            estadoContratacion: "",
            fecha: "",
        };

        await trackingMegamovil(obj.clientId).then((response) => {
            if (response && response.data.data[0]) {
                data.status = response.data.data[0].status;
                data.message = response.data.data[0].message;
                data.estadoContratacion = response.data.data[0].estadoContratacion;
                data.fecha = response.data.data[0].fecha;
                data.paquete = response.data.data[0].paquete;
            }
        }).catch(() => { });

        return data;
    }
);

//-------------------------------------------------------------------------------------------------- Slice
const megamovilTrackingSlice = createSlice({
    name: "megaMovil",
    initialState: movilTrackingInitialState,
    reducers: {
        setTrackingMegamovilData: (state, action: PayloadAction<TrackingMegaMovilData>) => {
            state.clientId = action.payload.clientId;
            state.status = action.payload.status;
            state.message = action.payload.message;
            state.estadoContratacion = action.payload.estadoContratacion;
            state.fecha = action.payload.fecha;
            state.paquete = action.payload.paquete;         
        },
        clearTrackingMegamovilData: (action) => {
            action.clientId = movilTrackingInitialState.clientId;
            action.status = movilTrackingInitialState.status;
            action.message = movilTrackingInitialState.message;
            action.estadoContratacion = movilTrackingInitialState.estadoContratacion;
            action.fecha = movilTrackingInitialState.fecha;
            action.paquete = movilTrackingInitialState.paquete;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fillMegaMovilTrackingSlice.fulfilled, (state, action) => {
            state.clientId = action.payload.clientId;
            state.status = action.payload.status;
            state.message = action.payload.message;
            state.estadoContratacion = action.payload.estadoContratacion;
            state.fecha = action.payload.fecha;
            state.paquete = action.payload.paquete;
        });
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export { fillMegaMovilTrackingSlice };
export const {
    setTrackingMegamovilData,
    clearTrackingMegamovilData,
} = megamovilTrackingSlice.actions;

export const getTrackingMegamovilData = (state: any) => state.megaMovil as TrackingMegaMovilData;

export default megamovilTrackingSlice.reducer;
